import { ofType } from 'redux-observable';
import { concatMap, from, map } from 'rxjs';

import { TRACKING_ACTION_TYPES } from '@spa/shared/store/actions/tracking';
import { dispatchWithNextState } from '@spa/shared/utils/store';

export const track = (action$, _, { store: { dispatch } }) =>
  action$.pipe(
    ofType(TRACKING_ACTION_TYPES.TRACK),
    concatMap(({ payload: { services, data, options = {} } }) =>
      from(services).pipe(
        concatMap((service, index) =>
          from(service.track(data, options)).pipe(
            map(() => {
              const payload = { type: 'empty_task' };

              return index === services.length - 1 ? payload : dispatchWithNextState(payload, dispatch);
            })
          )
        )
      )
    )
  );
